import { Button, Icon, Modal } from '@fasstech/middle-design-system';
import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';

import BankInformations from './BankInformations';
import { isRequired } from '@@viewHelpers/validations';
import { assoc, inc, includes, map, propOr } from 'ramda';
import { getBeneficiaryType } from './helpers';
import { ControlledRadioButton } from '@@viewCommonComponents/controlled';
import { FormLayout } from '@@viewCommonComponents/forms/Layouts.jsx';

const BeneficiaryRefund = ({
  index,
  selectedTab,
  handleRemoveBeneficiary,
  getMiddleText,
  getMiddleBoolean,
  availableGranteesId,
  fields,
  granteesWithoutBankAccount
}) => {
  const [displayModal, setDisplayModal] = useState(false);

  const form = useFormContext();
  const {
    watch
  } = form;

  const granteeId = watch(`grantees.${index}.id`);

  const granteeTypes = map((grantee) => {
    const granteeOptionsValues = getBeneficiaryType(getMiddleText, grantee);
    return assoc('disabled', includes(grantee.id, availableGranteesId), granteeOptionsValues);
  })(granteesWithoutBankAccount);

  const deleteBeneficiary = (index) => {
    handleRemoveBeneficiary(index);
    setDisplayModal(false);
  };

  const openModal = () => {
    setDisplayModal(true);
  };

  return (
    <>
      <FormLayout className={`${selectedTab !== inc(index) ? 'hidden' : ''}`} key={granteeId}>
        <Modal
          isDisplayed={displayModal}
          button1Label={'Confirmer la suppression'}
          button2Label={'Annuler la suppression'}
          onClose={() => setDisplayModal(false)}
          onClick1={() => deleteBeneficiary(index)}
          onClick2={() => setDisplayModal(false)}
          icon="circleReject">
          <div className="w-[60%] mx-auto text-primary font-medium text-xl text-center">
            <p>{'Êtes-vous sûr de vouloir supprimer les informations de ce bénéficiaire ?'}</p>
          </div>
        </Modal>
        <ControlledRadioButton
          options={granteeTypes}
          name={`grantees.${index}.id`}
          disabled={includes(propOr(null, 'id', fields[index]), availableGranteesId)}
          form={form}
          rules={{ ...isRequired }}
          className={'grid grid-cols-1 md:grid-cols-3!'}
          variant="button"
          label={'Bénéficiaire'}
          data-testid="grantee"
        />
        <BankInformations
          fieldsPrefix={`grantees.${index}.bankAccounts.0`}
          getMiddleText={getMiddleText}
          getMiddleBoolean={getMiddleBoolean}
          isCustomer={false}
        />
      </FormLayout>
      <Button
        data-testid="REMOVE_BENEFICIARY_IBAN_BUTTON"
        variant="text"
        onClick={openModal}
        className={`flex justify-start! p-0! font-bold w-full whitespace-nowrap ${selectedTab !== inc(index) ? 'hidden' : ''} `}>
        <div className={'flex items-center'}>
          <Icon className={'mr-3 ml-1'} name="delete" size={14} />
          {'Supprimer ce RIB'}
        </div>
      </Button>
    </>
  );
};

BeneficiaryRefund.propTypes = {
  handleRemoveBeneficiary: PropTypes.func,
  displayInformations: PropTypes.number,
  setDisplayInformations: PropTypes.func,
  index: PropTypes.number,
  beneficiaries: PropTypes.array
};

export default BeneficiaryRefund;
